import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import InfoButton from '../info-button/InfoButton';
import {
  GetInvolvedPreviewContainer,
  GetInvolvedFlexContainer,
  GetInvolvedPreviewHeader,
  GetInvolvedPreviewText,
  GetInvolvedFlexText,
  GetInvolvedPreviewGridDesktop,
  GetInvolvedPreviewGridMobile,
  GetInvolvedPreviewMic,
} from './GetInvolvedPreview.style';
import { icons } from '../../style/icons';
import { MarginContainer } from '../../lib/shared';

const GetInvolvedPreview = () => {
  const pageQuery = useStaticQuery(graphql`
    query InvolvedQuery {
      prismicGetInvolvedPreview {
        data {
          get_involved_blurb {
            text
          }
          volunteer_button_display_text {
            text
          }
          get_involved_header {
            text
          }
          volunteer_link {
            url
          }
        }
      }
    }
  `);

  const {
    prismicGetInvolvedPreview: {
      data: {
        get_involved_header: getInvolvedHeader,
        get_involved_blurb: getInvolvedBlurb,
        volunteer_link: volunteerLink,
        volunteer_button_display_text: volunteerButtonDisplayText,
      },
    },
  } = pageQuery;

  return (
    <GetInvolvedPreviewContainer>
      <GetInvolvedPreviewGridDesktop
        src={icons.GRID_LINES_DESKTOP.image}
        alt={icons.GRID_LINES_DESKTOP.altText}
      />
      <GetInvolvedPreviewGridMobile
        src={icons.GRID_LINES_MOBILE.image}
        alt={icons.GRID_LINES_MOBILE.altText}
      />
      <GetInvolvedFlexContainer>
        <MarginContainer>
          <GetInvolvedFlexText>
            <GetInvolvedPreviewHeader>
              {getInvolvedHeader.text}
            </GetInvolvedPreviewHeader>
            <GetInvolvedPreviewText>
              {getInvolvedBlurb.text}
            </GetInvolvedPreviewText>

            <InfoButton
              buttonLink={volunteerLink.url}
              buttonText={volunteerButtonDisplayText.text}
            />
          </GetInvolvedFlexText>
        </MarginContainer>
        <GetInvolvedPreviewMic
          src={icons.MIC2_YELLOWGREEN_POP.image}
          alt={icons.MIC2_YELLOWGREEN_POP.altText}
        />
      </GetInvolvedFlexContainer>
    </GetInvolvedPreviewContainer>
  );
};

export default GetInvolvedPreview;
